<template lang="pug">
.sign-container(@touchmove.prevent)
  .sign-block
    .close-block(@click="closeModal")
      img(src="https://m.hellobike.com/resource/helloyun/08345/Pe7OEngKfX.png?x-oss-process=image/quality,q_80")
    .receive-packet-block
      .sign-title 你今天还未签到哦～
      .sign-word
        span 超级会员签到得
        span.red-word {{blockNum}}倍奖励金
        span ，享
      .sign-word 全额抵扣充话费
      .sign-img
        img(:src="blockImg")
      .sign-button(@click="goShare") 去签到
    .shadow
</template>

<script>
import Lottie from '@/components/lottie';
import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { Navigator } from '@hb/h5-navigator';
import { desc, getName } from '../utils.js';
import config from '../../../../const/config';

export default {
  components: {
    Lottie,
  },
  props: {
    couponInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      blockImg: null,
      blockNum: null,
    };
  },
  created() {
    if (!env.isEasyBikeApp) {
      this.blockImg = 'https://m.hellobike.com/resource/helloyun/08345/34MbIJhRXi.png?x-oss-process=image/quality,q_80';
      this.blockNum = 6;
    } else {
      this.blockImg = 'https://m.hellobike.com/resource/helloyun/08345/vDjrG27TRa.png?x-oss-process=image/quality,q_80';
      this.blockNum = 3;
    }
  },
  mounted() {
  },
  methods: {
    desc,
    getName,
    closeModal() {
      this.$emit('update:show', false);
    },
    async goShare() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_sign_in_pop',
        categoryId: 'platform',
        businessInfo: {},
      });
      const bountyUrl = `https://m.hellobike.com/AppPlatformH5/${config.env === 'pro' ? '' : `${config.env}/`}latest/index.html#/bounty`;
      Navigator.go(bountyUrl);
      this.closeModal();
    },
  },
};
</script>
<style lang="less" scoped>
.sign-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 222;

  .sign-block {
    width: 3.2rem;
    height: 3.09rem;
    margin: 2rem auto;
    position: relative;

    .close-block {
      position: absolute;
      top: 0.13rem;
      right: 0.13rem;
      z-index: 230;

      img {
        width: 0.14rem;
        height: 0.14rem;
      }
    }

    .receive-packet-block {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      z-index: 101;
      position: relative;
      background: linear-gradient(180deg, #fff 0%, #fffae9 100%);
      border-radius: 0.16rem;

      .sign-title {
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 0.2rem;
        font-weight: 500;
        line-height: 0.28rem;
        text-align: center;
        padding-top: 0.28rem;
        color: 242729;
        margin-bottom: 0.05rem;
      }

      .sign-word {
        text-align: center;
        color: #5a6066;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-size: 0.17rem;
        font-weight: 400;

        .red-word {
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #ff5526;
        }
      }

      .sign-img {
        margin-top: 0.28rem;
        margin-bottom: 0.26rem;
        display: flex;
        justify-content: center;

        img {
          width: 1.74rem;
          height: 0.73rem;
        }
      }

      .sign-button {
        margin: 0 auto;
        width: 2.72rem;
        height: 0.48rem;
        text-align: center;
        line-height: 0.48rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 0.18rem;
        font-weight: 500;
        background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
        color: #fff;
        border-radius: 0.5rem;
      }
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
}
</style>
